const each = function (collection, callback) {
    if (Array.isArray(collection) && collection.length > 0) {
        for (const index in collection) {
            callback(collection[index], index);
        }
    }
};
export { each };
export default each;
